// i18next-extract-mark-ns-start SEO
const baseConfig = {
  photo: '/header.jpg',
};

const english = {
  ...baseConfig,
  title: 'Artisan Tailoring & Cobbler Services at Your Door | Tilli',
  // eslint-disable-next-line max-len
  description: 'Book expert tailor and cobbler services with Tilli. Alterations and repairs for clothing, bags, and shoes. Restoration and cleaning services for bags and shoes. At-home service or parcel delivery, close to you. Get an online quote in 2 minutes for fast and personalized service.',
  baseUrl: 'https://tilli.com',
};

const french = {
  ...baseConfig,
  title: 'Votre Artisan couturier - cordonnier, à domicile | Tilli',
  // eslint-disable-next-line max-len
  description: 'Réservez les services de nos couturiers et cordonniers experts avec Tilli. Retouches et réparations de vêtements, sacs et chaussures. Nettoyage de sacs et chaussures. Service à domicile ou par envoi de colis, au plus près de vous. Obtenez un devis en ligne en 2 min pour un service rapide et personnalisé.',
  baseUrl: 'https://tilli.fr',
};

// cspell:disable-next-line
const spanish = {
  ...baseConfig,
  // cspell:disable-next-line
  title: 'Tilli | Tu Artesano sastre y zapatero, a domicilio | Tilli',
  /* cspell:disable */
  // eslint-disable-next-line max-len
  description: 'Reserva los servicios de nuestros sastres y zapateros expertos con Tilli. Arreglos y reparaciones de ropa, bolsos y zapatos. Restauración y limpieza de bolsos y zapatos. Servicio a domicilio o envío de paquetes, cerca de ti. Obtén un presupuesto online en 2 minutos para un servicio rápido y personalizado.',
  /* cspell:enable */
  baseUrl: 'https://tilli.com',
};

// cspell:disable-next-line
const italian = {
  ...baseConfig,
  // cspell:disable-next-line
  title: 'Il tuo Artigiano sarto e calzolaio a casa tua | Tilli',
  /* cspell:disable */
  // eslint-disable-next-line max-len
  description: 'Prenota i servizi dei nostri esperti sarti e calzolai con Tilli. Modifiche e riparazioni di abiti, borse e scarpe. Restauro e pulizia di borse e scarpe. Servizio a domicilio o spedizione di pacchi, vicino a te. Ottieni un preventivo online in 2 minuti per un servizio rapido e personalizzato.',
  /* cspell:enable */
  baseUrl: 'https://tilli.com',
};

const german = {
  ...baseConfig,
  // cspell:disable-next-line
  title: 'Dein Schneider und Schuhmacher direkt zu dir nach Hause | Tilli',
  /* cspell:disable */
  // eslint-disable-next-line max-len
  description: 'Buchen Sie die Dienste unserer Experten für Schneider und Schuhmacher bei Tilli. Änderungen und Reparaturen von Kleidung, Taschen und Schuhen. Restaurierung und Reinigung von Taschen und Schuhen. Service vor Ort oder Paketsendung, in Ihrer Nähe. Holen Sie sich ein Online-Angebot in 2 Minuten für schnellen und personalisierten Service.',
  /* cspell:enable */
  baseUrl: 'https://tilli.com',
};

// cspell:disable-next-line
const portuguese = {
  ...baseConfig,
  // cspell:disable-next-line
  title: 'O seu Artesão costureiro e sapateiro à porta | Tilli',
  /* cspell:disable */
  // eslint-disable-next-line max-len
  description: 'Reserve os serviços dos nossos costureiros/costureiras e sapateiros especializados com a Tilli. Alterações e reparos em roupas, bolsas e sapatos. Restauração e limpeza de bolsas e sapatos. Serviço em casa ou envio de pacotes, perto de você. Obtenha um orçamento online em 2 minutos para um serviço rápido e personalizado.',
  /* cspell:enable */
  baseUrl: 'https://tilli.com',
};

const getConfig = (language) => {
  if (language === 'en') return english;
  // cspell:disable-next-line
  if (language === 'es') return spanish;
  // cspell:disable-next-line
  if (language === 'it') return italian;
  if (language === 'de') return german;
  // cspell:disable-next-line
  if (language === 'pt') return portuguese;
  return french;
};

export default getConfig;
